<template>

    <FloatingPanel>

        <div class="canvas-blocks-custom-projectSlider-BlockPanel">

            <Tabs :tabs="[
                'Algemeen',
                'Design',
            ]">

                <div slot="Algemeen">

                    <SwitchInput
                        label="Welke projecten tonen?"
                        instruction=""
                        :options="options"
                        options-property="customOrLatest"
                        :items="[
                            { value: 'custom', label: 'Zelf kiezen'},
                            { value: 'latest', label: 'Laatste projecten'},
                        ]"
                        defaultValue="latest"
                        :open="true"
                    />

                </div>

                <div slot="Design">

                    <CommonInputs
                        :options="options"
                    />

                </div>

            </Tabs>

        </div>

    </FloatingPanel>

</template>

<script>

import AbstractPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/AbstractPanel";
import FloatingPanel from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/FloatingPanel";
import CommonInputs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/CommonInputs";
import SwitchInput from "@galaxy/modules/Canvas/resources/js/editor/website/editors/inputs/SwitchInput";
import Tabs from "@galaxy/modules/Canvas/resources/js/editor/website/editors/panels/Tabs";

export default {

    extends: AbstractPanel,

    components: {
        FloatingPanel,
        CommonInputs,
        SwitchInput,
        Tabs,
    },

}

</script>
